export default __webpack_public_path__ + "static/radialPlus-9a579261c2e415f14c5e9529daa63cfd.png";